import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQ } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="sss" data-testid="faq-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <span className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">Sık Sorulan Sorular</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
            Aklındaki her soru.
          </h2>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="space-y-3">
          {FAQ.map((f, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                variants={fadeUp}
                custom={i}
                data-testid={`faq-item-${i}`}
                className={`rounded-2xl border transition-colors ${isOpen ? "border-[#1B19A8]/30 bg-[#f7f9fa]" : "border-black/5 bg-[#f7f9fa]"}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left p-6"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="font-display text-lg font-bold text-[#1a1a1a]">{f.q}</span>
                  <span className={`shrink-0 grid place-items-center w-9 h-9 rounded-full transition-colors ${isOpen ? "bg-[#1B19A8] text-white" : "bg-white text-[#1B19A8] border border-black/10"}`}>
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <motion.div
                  initial={false}
                  animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
                  transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                  className="overflow-hidden"
                >
                  <p className="px-6 pb-6 text-[#1a1a1a]/70 leading-relaxed">{f.a}</p>
                </motion.div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
